export const [
    MEMBER,
    ADMIN,
    SUPERADMIN,
    MASTER,
    SHIPPOP,
    SHIPPOP_ADMINISTRATOR,
    SHIPPOP_HEAD,
    SHIPPOP_SENIOR,
    SHIPPOP_ENGINEER,
    SHIPPOP_BUSINESS_DEVELOPMENT,
    SHIPPOP_CUSTOMER_SERVICE,
    SHIPPOP_MARKETING,
    SHIPPOP_SALES,
    SHIPPOP_ACCOUNTING,
    SHIPPOP_JUNIOR,
    SHIPPOP_INTERN
] = [
    "member",
    "admin",
    "superadmin",
    "master",
    "shippop",
    "SHIPPOP_ADMINISTRATOR",
    "SHIPPOP_HEAD",
    "SHIPPOP_SENIOR",
    "SHIPPOP_ENGINEER",
    "SHIPPOP_BUSINESS_DEVELOPMENT",
    "SHIPPOP_CUSTOMER_SERVICE",
    "SHIPPOP_MARKETING",
    "SHIPPOP_SALES",
    "SHIPPOP_ACCOUNTING",
    "SHIPPOP_JUNIOR",
    "SHIPPOP_INTERN"
];

export const getRole = {
    MEMBER,
    ADMIN,
    SUPERADMIN,
    MASTER,
    SHIPPOP,
    SHIPPOP_ADMINISTRATOR,
    SHIPPOP_HEAD,
    SHIPPOP_SENIOR,
    SHIPPOP_ENGINEER,
    SHIPPOP_BUSINESS_DEVELOPMENT,
    SHIPPOP_CUSTOMER_SERVICE,
    SHIPPOP_MARKETING,
    SHIPPOP_SALES,
    SHIPPOP_ACCOUNTING,
    SHIPPOP_JUNIOR,
    SHIPPOP_INTERN
}

export const getRoleAuth0 = {
    SHIPPOP_ADMINISTRATOR,
    SHIPPOP_HEAD,
    SHIPPOP_SENIOR,
    SHIPPOP_ENGINEER,
    SHIPPOP_BUSINESS_DEVELOPMENT,
    SHIPPOP_CUSTOMER_SERVICE,
    SHIPPOP_MARKETING,
    SHIPPOP_SALES,
    SHIPPOP_ACCOUNTING,
    SHIPPOP_JUNIOR,
    SHIPPOP_INTERN
};